import React from "react";
import { ActivityStateMixin, ActivityStateMixinState } from "../activities/ActivityStateMixin";
import { AppState } from "../system/AppState";

const useMixin = (appState: AppState) => {
  const [internalMixin, setInternalMixin] = React.useState<ActivityStateMixinState>();

  React.useEffect(() => {
    const activityStateMixin = new ActivityStateMixin(setInternalMixin, appState);

    return () => {
      activityStateMixin.componentWillUnmount();
    };
  }, [appState]);

  const mixin = React.useMemo(() => {
    if (internalMixin !== undefined) {
      return internalMixin;
    }

    return {
      appCaregiverState: appState.appCaregiverState,
      appVisitsState: appState.appVisitsState,
      appVisitEditRequestsState: appState.appVisitEditRequestsState,
      appAgenciesState: appState.appAgenciesState,
      appChatState: appState.chatState.getAppChatState(),
      notificationsState: appState.notificationState,
      scheduledVisits: appState.scheduledVisits,
      appTasksState: appState.appTasksState,
      appTaskBroadcastsState: appState.appTaskBroadcastsState,
    };
  }, [
    appState.appAgenciesState,
    appState.appCaregiverState,
    appState.appTaskBroadcastsState,
    appState.appTasksState,
    appState.appVisitEditRequestsState,
    appState.appVisitsState,
    appState.chatState,
    appState.notificationState,
    appState.scheduledVisits,
    internalMixin,
  ]);

  return mixin;
};

export default useMixin;
